import React from "react";
import {
  Button,
  Modal,
  Input,
  DatePicker,
  TimePicker,
} from "antd";
import "./UpdateEventModal.scss";
import { Controller } from "react-hook-form";
import useEventEditModal from "./logic/useEventEditModal";
import { MdCloudUpload, MdDelete } from "react-icons/md";
import { AiFillFileImage } from "react-icons/ai";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
const UpdateEventModal = ({ isModalEditOpen, setIsModalEditOpen, idEvent,includeUpcoming }) => {
  const handleCancel = () => {
    setIsModalEditOpen(!isModalEditOpen);
  };

  const {
    control,
    handleSubmit,
    errors,
    setValue,
    watch,
    onUpdateEvent,
    isLoadingEventDetails,
  } = useEventEditModal(idEvent, setIsModalEditOpen, includeUpcoming, isModalEditOpen);

  const disabledDate = (current) => {
    return current && current < dayjs().endOf('day');
  };

  return (
    <Modal
      title={
        <h1
          style={{
            color: "#185993",
            fontWeight: "600",
            fontSize: "1.2rem",
          }}
        >
          Update Event
        </h1>
      }
      centered
      open={isModalEditOpen}
      onCancel={() => setIsModalEditOpen(false)}
      width={800}
      footer={[
        <Button key="back" onClick={() => handleCancel()}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit(onUpdateEvent)}
        >
          Edit
        </Button>,
      ]}
    >
      <form onSubmit={handleSubmit(onUpdateEvent)}>
        <div className="form-control-modal-event">
          <div className="first-row-modal-event">
            <div className="form-item">
              <label>Title</label>
              <div className="input-container">
                <Controller
                  name="title"
                  control={control}
                  defaultValue=""
                  rules={{ required: "title is required" }}
                  render={({ field }) => (
                    <Input placeholder="Enter a title" {...field} />
                  )}
                />
              </div>
              {errors.title && (
                <span className="error-msg">{errors.title.message}</span>
              )}
            </div>
          </div>
          <div className="first-row-modal-event">
            <div className="form-item">
              <label>Location</label>
              <div className="input-container">
                <Controller
                  name="location"
                  control={control}
                  defaultValue=""
                  rules={{ required: "location is required" }}
                  render={({ field }) => (
                    <Input placeholder="Enter a location" {...field} />
                  )}
                />
              </div>
              {errors.location && (
                <span className="error-msg">{errors.location.message}</span>
              )}
            </div>
          </div>
          <div className="second-row-modal-event">
            <div className="form-item">
              <label>Date</label>
              <div className="input-container">
                <Controller
                  name="date"
                  control={control}
                  rules={{ required: "date is required" }}
                  render={({ field }) => (
                    <DatePicker format="YYYY-MM-DD" {...field} disabledDate = {disabledDate} />
                  )}
                />
              </div>
              {errors.date && (
                <span className="error-msg">{errors.date?.message}</span>
              )}
            </div>
            <div className="form-item">
              <label>Time</label>
              <div className="input-container">
                <Controller
                  name="range"
                  control={control}
                  rules={{ required: "time is required" }}
                  render={({ field }) => (
                    <TimePicker.RangePicker
                      format="h:mm a"
                      onChange={(timeValue) => {
                        const start_time = timeValue[0]?.format("HH:mm") || "";
                        const end_time = timeValue[1]?.format("HH:mm") || "";
                        const timeRange = { start_time, end_time };
                        field.onChange(timeRange);
                      }}
                      {...field}
                    />
                  )}
                />
              </div>
              {errors.range && (
                <span className="error-msg">{errors.range?.message}</span>
              )}
            </div>
          </div>
          <div className="second-row-modal-event">
            <div className="form-item">
              <label>Longitude </label>
              <div className="input-container">
                <Controller
                  name="longitude"
                  control={control}
                  render={({ field }) => (
                    <Input {...field} placeholder="Enter a longitude" />
                  )}
                />
              </div>
            </div>
            <div className="form-item">
              <label>Latitude </label>
              <div className="input-container">
                <Controller
                  name="latitude"
                  control={control}
                  render={({ field }) => (
                    <Input {...field} placeholder="Enter a latitude" />
                  )}
                />
              </div>
            </div>
            <div className="form-item">
              <label>PlaceQuery </label>
              <div className="input-container">
                <Controller
                  name="placeQuery"
                  control={control}
                  render={({ field }) => (
                    <Input {...field} placeholder="Enter a placeQuery" />
                  )}
                />
              </div>
            </div>
          </div>
          <div className="fourth-row-modal-event">
            <div className="form-item">
              <label>Description </label>
              <div className="input-container">
                <Controller
                  name="description"
                  control={control}
                  defaultValue=""
                  rules={{ required: "description is required" }}
                  render={({ field }) => (
                    <TextArea
                      showCount
                      maxLength={750}
                      style={{
                        height: 120,
                        marginBottom: 24,
                      }}
                      placeholder="Enter a description"
                      {...field}
                    />
                  )}
                />
              </div>
              {errors.description && (
                <span className="error-msg">{errors.description?.message}</span>
              )}
            </div>
            <div className="form-item">
              <label>Image </label>
              <div>
                {isLoadingEventDetails ? (
                  <div className="enroll-image-section">loading ...</div>
                ) : (
                  <div
                    className="enroll-image-section"
                    onClick={() =>
                      document.querySelector(".input-field").click()
                    }
                  >
                    <Controller
                      name="file"
                      control={control}
                      render={({ field: { onChange } }) => (
                        <>
                          <input
                            type="file"
                            accept="image/*"
                            className="input-field"
                            hidden
                            onChange={({ target: { files } }) => {
                              if (files && files[0]) {
                                setValue("file", files[0]);
                                onChange(files[0]);
                              }
                            }}
                          />
                          {watch("file") ? (
                            <img
                              src={
                                typeof watch("file") === "string" // Check if it's a URL or a File object
                                  ? watch("file") // If it's a URL (existing image), use it as-is
                                  : URL.createObjectURL(watch("file")) // If it's a File object, create a preview URL
                              }
                              width={100}
                              height={100}
                              alt={watch("file").name}
                            />
                          ) : (
                            <>
                              <MdCloudUpload color="#1475cf" size={60} />
                              <p>Browse Files to upload</p>
                            </>
                          )}
                        </>
                      )}
                    />
                    <div
                      id="imgError"
                      className="form-error-message center-container"
                    ></div>
                  </div>
                )}

                <section className="uploaded-row">
                  <AiFillFileImage color="#1475cf" />
                  <span className="upload-content">
                    {watch("file") ? (
                      <>
                        {watch("file").name} -
                        <MdDelete
                          onClick={() => {
                            setValue("file", null);
                          }}
                        />
                      </>
                    ) : (
                      "No selected File"
                    )}
                  </span>
                </section>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateEventModal;
